<div class="single-field-edit"
  [class.employerSelectEdit]="employerSelectEdit"
  [class.employerEdit]="employerEdit"
  [class.moreBot]="moreBot"
  [class.save]="activeField === field"
  [class.toRight]="toRight"
  [class.offset]="offset"
  [class.offsetRight]="offsetRight"
  (click)="toggleField($event)"
  >
  @if (activeField !== field) {
    <div class="single-field-edit__button">
      <img src="../../assets/svg/new_edit.svg" alt="edit" class="single-field-edit__ico" />
    </div>
  }

  @if (activeField === field) {
    <div class="single-field-edit__button">
      <img src="../../assets/svg/new_save.svg" alt="edit" class="single-field-edit__ico-save" />
    </div>
  }
</div>
